import { ColGroupDef } from "ag-grid-enterprise";
import {
  dueDateCellRenderer,
  riskCellRenderer,
  submittalDueDateHeaderComponent
} from "components/cell-renders";
import { InnerIdLinkSubmittalRenderer } from "pages/reports-menu/components/cellRenderer";
import { submittalSequenceComparator } from "pages/submittals-log-page/utils";
import { TLinkedSubmittal } from "../models";
import {
  getActivityValueGetterData,
  getLinkedMaterialGetterData,
  valueGetterSubmittalBallInCourt,
  valueGetterSubmittalDueDate,
  valueGetterSubmittalId,
  valueGetterSubmittalRisk,
  valueGetterSubmittalSpecSection
} from "../utils/value-getters";
import { voidSubmittalCellRenderer } from "../cell-render/void-status-cell-render";
import CustomDateSetFilter from "entity-app/custom-filters/custom-date-filter";
import { riskLevelComparator } from "utils/grid-utils";

export const submittalColDefs = (params?: { projectDetails?: any }) => {
  const cellClass = (param: any) => {
    const { data, column } = param;

    // For deleted submittals
    if (data?.deleted_from_source) {
      if (column?.colId === "submittal_id") {
        return "deletedRiskSubCell";
      }
      return "deletedRiskSubCell italic";
    }

    return "riskSubCell";
  };

  return [
    {
      headerName: "Linked Submittals",
      children: [
        {
          colId: "submittal_id",
          field: "submittal_id",
          headerName: "Submittal ID",
          headerTooltip: "Submittal ID",
          cellRenderer: "agGroupCellRenderer",
          cellRendererParams: {
            innerRenderer: InnerIdLinkSubmittalRenderer
          },
          valueGetter: valueGetterSubmittalId,
          tooltipValueGetter: ({ value }) => value,
          getQuickFilterText: (param) => {
            const { data, value } = param;
            let allValues = [value];
            if (data.parentActivity) {
              allValues = allValues.concat(
                getActivityValueGetterData(data.parentActivity)
              );
            }
            if (data.parentMaterial) {
              allValues = allValues.concat(
                getLinkedMaterialGetterData({ data: data.parentMaterial })
              );

              if (data.parentMaterial.parentActivity) {
                allValues = allValues.concat(
                  getActivityValueGetterData(data.parentMaterial.parentActivity)
                );
              }
            }
            return allValues.join(" ");
          },
          comparator: (valueA, valueB, nodeA, nodeB) =>
            submittalSequenceComparator(
              nodeA.data?.submittal_id,
              nodeB.data?.submittal_id,
              nodeA,
              nodeB,
              params?.projectDetails?.spec_section
            ),
          cellClass
        },
        {
          colId: "specsection",
          headerName: "Spec Section",
          headerTooltip: "Spec Section",
          valueGetter: valueGetterSubmittalSpecSection,
          tooltipValueGetter: ({ value }) => value,
          cellClass
        },
        {
          colId: "title",
          field: "title",
          headerName: "Title",
          headerTooltip: "Title",
          tooltipField: "title",
          cellClass
        },
        {
          colId: "workflow_status",
          field: "workflow_status",
          headerName: "Status",
          headerTooltip: "Status",
          tooltipField: "workflow_status",
          cellRenderer: voidSubmittalCellRenderer,
          cellClass
        },
        {
          colId: "assignee",
          headerName: "Ball In Court",
          headerTooltip: "Ball In Court",
          valueGetter: valueGetterSubmittalBallInCourt,
          tooltipValueGetter: ({ value }) => value,
          cellClass
        },
        {
          colId: "due_date",
          headerName: "Due Date",
          headerTooltip: "Due Date",
          headerComponentParams: submittalDueDateHeaderComponent,
          valueGetter: valueGetterSubmittalDueDate,
          sort: "asc",
          cellRenderer: dueDateCellRenderer,
          tooltipValueGetter: ({ value }) => value,
          cellClass,
          filter: CustomDateSetFilter
        },
        {
          colId: "risk",
          headerName: "Risk",
          headerTooltip: "Risk",
          valueGetter: valueGetterSubmittalRisk,
          comparator: riskLevelComparator,
          cellRenderer: riskCellRenderer,
          tooltipValueGetter: ({ value }) => value,
          cellClass
        }
      ]
    }
  ] as ColGroupDef<TLinkedSubmittal>[];
};
